// Maps support two access levels only: Editor and Viewer.
export const MAP_ROLES = [
  { value: 'map_editor', label: 'Editor' },
  { value: 'map_viewer', label: 'Viewer' },
]

export const DEFAULT_MAP_ROLE = 'map_editor'

export const roleToName: Record<string, string> = {
  map_editor: 'Editor',
  map_viewer: 'Viewer',
}
